<aside
    class="fixed inset-0 z-[100] flex h-full w-full items-center justify-center overflow-y-auto bg-zinc-900/55 px-4 py-8 backdrop-blur-sm">
    <div class="tw-modal-panel max-w-md overflow-hidden">
        <!-- Hero -->
        <div
            class="flex flex-col items-center gap-5 px-7 pb-2 pt-9 text-center">
            <span
                class="flex size-12 items-center justify-center rounded-2xl bg-amber-50 text-amber-600 ring-1 ring-inset ring-amber-100 shadow-[0_0_0_6px_rgb(254,243,199,0.45)]">
                <lucide-icon
                    [img]="SparklesIcon"
                    [size]="22"
                    [strokeWidth]="1.75" />
            </span>
            <div class="flex flex-col gap-2">
                <h2
                    class="text-[20px] font-semibold leading-tight tracking-[-0.01em] text-twTextPrimary">
                    {{ KEYS.title | translate }}
                </h2>
                <p class="max-w-[360px] text-[13.5px] leading-relaxed text-zinc-500">
                    {{ KEYS.message | translate }}
                </p>
            </div>
        </div>

        <!-- Value props -->
        <div class="px-7 pt-6">
            <ul
                class="flex flex-col gap-2.5 rounded-xl border border-zinc-200/70 bg-zinc-50/40 px-4 py-3.5">
                @for (benefit of benefits; track benefit) {
                    <li class="flex items-start gap-2.5 text-[13px] leading-snug text-zinc-700">
                        <span
                            class="mt-[1px] flex size-4 shrink-0 items-center justify-center rounded-full bg-emerald-100 text-emerald-700">
                            <lucide-icon
                                [img]="CheckIcon"
                                [size]="11"
                                [strokeWidth]="2.5" />
                        </span>
                        <span>{{ benefit | translate }}</span>
                    </li>
                }
            </ul>
        </div>

        <!-- Price + CTA -->
        <div class="flex flex-col items-center gap-4 px-7 pb-7 pt-6">
            <div class="flex items-baseline gap-1">
                <span
                    class="text-[30px] font-bold leading-none tracking-[-0.02em] text-twTextPrimary tabular-nums">
                    {{ KEYS.price | translate }}
                </span>
                <span class="text-[13px] font-medium text-zinc-500">
                    {{ KEYS.pricePeriod | translate }}
                </span>
            </div>
            <button class="tw-btn-primary w-full" type="button" (click)="subscribe()">
                {{ KEYS.subscribe | translate }}
            </button>
        </div>
    </div>
</aside>
